
define( 'FORCES_AND_MOTION_BASICS/../nls/root/forces-and-motion-basics-strings',{
          "none": "None",
          "force": "Force",
          "values": "Values",
          "frictionTitle": "Friction",
          "redWins": "Red Wins!",
          "frictionForce": "Friction Force",
          "pause": "Pause",
          "friction": "Friction",
          "accelerationLab": "Acceleration Lab",
          "forces-and-motion-basics.name": "Forces and Motion: Basics",
          "leftForce": "Left Force",
          "appliedForce": "Applied Force",
          "rightForce": "Right Force",
          "massDisplay.pattern": "{0} kg",
          "acceleration": "Acceleration",
          "sound": "Sound",
          "lots": "Lots",
          "forces": "Forces",
          "tugOfWar": "Tug of War",
          "motion": "Motion",
          "go": "Go!",
          "sumOfForcesEqualsZero": "Sum of Forces = 0",
          "newtons.n": "Newtons (N)",
          "blueWins": "Blue Wins!",
          "sumOfForces": "Sum of Forces",
          "speed": "Speed",
          "return": "Return",
          "newtons": "Newtons",
          "masses": "Masses",
          "forceReadout.pattern": "{0}N"
        } );